import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '@/views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-furnitureshop-faq.js';

const plusIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M11 5h2v14h-2zM5 11h14v2H5z" />
  </svg>
`;

const minusIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M5 11h14v2H5z" />
  </svg>
`;

const faqItems = [
  {
    question: 'Does it protect against bird droppings?',
    answer:
      '<p>Yes. Our 9H coating resists chemicals, preventing bird droppings and acid rain from damaging paint, keeping your clear coat protected.</p>',
  },
  {
    question: 'Is it safe for all automotive paint types?',
    answer: `<p>Yes. This pH-neutral formula is safe for all paint types, enhancing gloss while preserving your vehicle's original finish.`,
  },
  {
    question: 'Can I use a pressure washer after application?',
    answer:
      '<p>Yes. After 24-hour curing, hydrophobic coating improves pressure washing. Avoid spraying within 12 inches to maintain coating durability.',
  },
  {
    question: 'Do I need to reapply this every month?',
    answer:
      'No. Advanced polymer coating lasts months, forming a semi-permanent bond, reducing reapplication while maintaining long-lasting protection and shine.',
  },
];

const renderFaqItem = ({ question, answer }) => {
  const isOpen = false;
  return `
    <div
      class="furnitureshop-faq__item${isOpen ? ' is-active' : ''}"
      data-attribute="furnitureshop-faq__item"
      data-active="${isOpen ? 'true' : 'false'}"
    >
      <div class="furnitureshop-faq__question item-question" data-attribute="item-question">
        <h3 data-attribute="furnitureshop-faq__question">${question}</h3>
        <span data-attribute="icon-minus"${isOpen ? '' : ' style="display: none"'}>${minusIcon}</span>
        <span data-attribute="icon-plus"${isOpen ? ' style="display: none"' : ''}>${plusIcon}</span>
      </div>
      <div
        class="furnitureshop-faq__answer item-answer${isOpen ? ' open' : ''}"
        data-attribute="item-answer"
        ${isOpen ? 'style="max-height: 300px"' : ''}
      >
        <div class="furnitureshop-faq__answer-content" data-attribute="furnitureshop-faq__answer">
          ${answer}
        </div>
      </div>
    </div>
  `;
};

const buttonHtml = buttonPrimary({
  text: 'BUY NOW',
  backgroundColor: '#FF8100',
  color: '#FFFFFF',
  radius: 5,
  iconPrefix: { show: false, src: '' },
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a85790b9a1e4455d92f0d2b.avif?w=200',
  },
  subBtn: { show: false, text: '' },
});

const contentHtml = `
  <div class="furnitureshop-faq container" data-attribute="furnitureshop-faq">
    <div class="furnitureshop-faq__title" data-attribute="furnitureshop-faq__title">
      <h2 style="text-align:center;"><span style="font-size:40px;"><strong>Read Our FAQ</strong></span></h2>
    </div>
    <div class="furnitureshop-faq__list" data-attribute="furnitureshop-faq__list">
      ${faqItems.map(renderFaqItem).join('')}
    </div>
    <div class="furnitureshop-faq__cta" data-attribute="furnitureshop-faq__cta">
      ${buttonHtml}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#FFFFFF',
  textColor: '#191919',
});
